<template>
  <div>
    <TheSheetIssuedExternalCouponNotification
      ref="TheSheetIssuedExternalCouponNotification"
      :retry="retryIssuedExternalCoupon"
      :openCouponVersionWarning="openCouponVersionWarning"
      :isNotTargetVersion="isNotTargetVersion"
    />

    <!-- ヘッダー -->
    <TheMyticketHeader
      :ticketName="displaySheetName(bookGroup, masterSheet)"
      :clickBackButtonEvent="returnNativeApp"
    />

    <div class="bg-img">
      <!-- 仕様枚数とチェック場所 -->
      <TheSheetUsedUpper />

      <TheDotLine />

      <!-- カウントダウンとアニメーションとチェック日時 -->
      <TheSheetUsedLower />
    </div>
  </div>

  <DialogCouponVersionWarning ref="DialogCouponVersionWarning" />
</template>

<script>
// Vue
import { onMounted, computed, ref, watchEffect } from "vue";
import { useStore } from "vuex";

// API
import API from "@/API";

export default {
  name: "TemplateSheetUsed",
  props: {
    issuedExternalCoupon: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const store = useStore();

    const TheSheetIssuedExternalCouponNotification = ref(null);
    const intervalHideIssuedExternalCouponNotification = ref(null);
    const DialogCouponVersionWarning = ref(null);

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);

    const appVersion = computed(() => store.getters["common/appVersion"]);
    const device = computed(() => store.getters["common/device"]);
    const isNotTargetVersion = ref(false);

    onMounted(async () => {
      if (props.issuedExternalCoupon != null) {
        console.log("props.issuedExternalCoupon::", props.issuedExternalCoupon);
        showIssueExternalCouponNotification(props.issuedExternalCoupon);
      }
    });

    const showIssueExternalCouponNotification = (isSuccess) => {
      TheSheetIssuedExternalCouponNotification.value.showNotification(
        isSuccess
      );

      //reset 10s for retry action
      if (intervalHideIssuedExternalCouponNotification.value != null) {
        clearTimeout(intervalHideIssuedExternalCouponNotification.value);
      }

      intervalHideIssuedExternalCouponNotification.value = setTimeout(() => {
        TheSheetIssuedExternalCouponNotification.value.hideNotification();
      }, 10 * 1000);
    };

    const retryIssuedExternalCoupon = async () => {
      try {
        const numberCouponIssued = await API.retryIssuedExternalCoupon(
          masterBook.id,
          book.id
        );
        if (numberCouponIssued >= 0) {
          showIssueExternalCouponNotification(true);
        }
      } catch (err) {
        showIssueExternalCouponNotification(false);
        console.log("retryIssuedExternalCoupon :>> issue coupon fail");
      }
    };

    const openCouponVersionWarning = () => {
      DialogCouponVersionWarning.value.openDialog();
    };

    // 対象のバージョンかどうか確認
    const checkVersion = () => {
      let bool = false;
      switch (device.value) {
        case "IOS":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.1");
          break;
        case "ANDROID":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.1");
          break;
        default:
          bool = false;
          break;
      }
      isNotTargetVersion.value = bool;
    };

    // x.x.x(string)のバージョンを、比較用の数値に変換する
    const convertVersionForCompare = (ver) => {
      const verNums = ver.split(".");
      return verNums[0] * 100 + verNums[1] * 10 + verNums[2];
    };

    watchEffect(() => {
      if (appVersion.value != null && appVersion.value != undefined) {
        checkVersion();
      }
    });

    return {
      bookGroup,
      masterSheet,
      TheSheetIssuedExternalCouponNotification,
      showIssueExternalCouponNotification,
      retryIssuedExternalCoupon,
      openCouponVersionWarning,
      isNotTargetVersion,
      DialogCouponVersionWarning,
    };
  },
};
</script>
